import { type CreditType } from "../components/creditProgressBarConfig";

export type CreditProgressBarLabelStatus = "available" | "unavailable" | "earned";

export function getCreditProgressBarLabel(
  creditType: CreditType,
  status: CreditProgressBarLabelStatus
): string {
  const prefix = creditType === "cancellation" ? "Same-day cancellation" : "Lateness";
  return `${prefix} credit ${status}`;
}
